function otherHouseholdIncomeRangeSelected(e) {
    if ($('.household-income-ranges :checkbox:checked').length > 0) {
        $('.household-income-ranges :checkbox:last').removeAttr('checked');
    }
}
function allHouseholdIncomeRangeSelected(e) {
    if ($('.household-income-ranges :checkbox:checked').length > 0) {
        $('.household-income-ranges :checkbox:not(".household-income-ranges :checkbox:last")').removeAttr('checked');
    }
}